import LegalDocumentPage from '../components/legal-page/LegalDocumentPage';

export default function LegalPage() {
  return <LegalDocumentPage pageKey="legal" />;
}
